import React from 'react';
import PropTypes from 'prop-types';
import Grid from '@sendgrid/style-guide-grid';
import { Radio } from '@sendgrid/ui-components/radio';
import withProfileInputs from '../containers/withProfileInputs';
import PROFILE from '../constants/profile';
import { WriteSelectors } from './companyInfo-qa-hooks';

export const CompanyInfo = props => (
  <section>
    <div className={Grid.row} data-role="company-info-container">
      <p className={`form-prompt ${Grid['col-12']}`} data-role="employee-count-prompt">
      How many employees work at your company?
        {' '}
        <span className="required-dot">&bull;</span>
      </p>
      <div className={Grid['col-6']}>
        <Radio
          checked={props.profileInputs.employeeCount === PROFILE.LV_EMPLOYEE}
          name="employeeCountRadios"
          id="radio-company-size-lv"
          label={PROFILE.LV_EMPLOYEE}
          value={PROFILE.LV_EMPLOYEE}
          data-role="radio-company-size-lv"
          onChange={props.setEmployeeCount}
          {...WriteSelectors.radioEmployeeCountLV}
        />
      </div>
      <div className={Grid['col-6']}>
        <Radio
          checked={props.profileInputs.employeeCount === PROFILE.MHV_EMPLOYEE}
          name="employeeCountRadios"
          id="radio-company-size-mhv"
          label={PROFILE.MHV_EMPLOYEE}
          value={PROFILE.MHV_EMPLOYEE}
          data-role="radio-company-size-mhv"
          onChange={props.setEmployeeCount}
          {...WriteSelectors.radioEmployeeCountMHV}
        />
      </div>
    </div>
    <div className={Grid.row} data-role="company-info-container">
      <div className={Grid['col-6']}>
        <Radio
          checked={props.profileInputs.employeeCount === PROFILE.MLV_EMPLOYEE}
          name="employeeCountRadios"
          id="radio-company-size-mlv"
          label={PROFILE.MLV_EMPLOYEE}
          value={PROFILE.MLV_EMPLOYEE}
          data-role="radio-company-size-mlv"
          onChange={props.setEmployeeCount}
          {...WriteSelectors.radioEmployeeCountMLV}
        />
      </div>
      <div className={Grid['col-6']}>
        <Radio
          checked={props.profileInputs.employeeCount === PROFILE.HV_EMPLOYEE}
          name="employeeCountRadios"
          id="radio-company-size-hv"
          label={PROFILE.HV_EMPLOYEE}
          value={PROFILE.HV_EMPLOYEE}
          data-role="radio-company-size-hv"
          onChange={props.setEmployeeCount}
          {...WriteSelectors.radioEmployeeCountHV}
        />
      </div>
    </div>
  </section>
);

CompanyInfo.propTypes = {
  setEmployeeCount: PropTypes.func.isRequired,
  profileInputs: PropTypes.shape({
    employeeCount: PropTypes.string.isRequired,
  }).isRequired,
};

export default withProfileInputs(CompanyInfo);
